import { useEffect, useRef, type ReactNode } from 'react';

type Props = {
  open: boolean;
  onClose: () => void;
  trigger: ReactNode;
  children: ReactNode;
  className?: string;
  align?: 'start' | 'end' | 'center';
};

export function Popover({ open, onClose, trigger, children, className, align = 'center' }: Props) {
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: Event) => {
      const path = (e as Event & { composedPath?: () => EventTarget[] }).composedPath?.() ?? [];
      const target = e.target as Node;
      if (wrapRef.current && (wrapRef.current.contains(target) || path.includes(wrapRef.current))) return;
      onClose();
    };
    const onEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    // Отложенная регистрация: иначе тот же touch-event который открыл попап его и закроет
    const tid = setTimeout(() => {
      document.addEventListener('pointerdown', onDoc, true);
      document.addEventListener('keydown', onEsc);
    }, 0);
    return () => {
      clearTimeout(tid);
      document.removeEventListener('pointerdown', onDoc, true);
      document.removeEventListener('keydown', onEsc);
    };
  }, [open, onClose]);

  return (
    <div className={`tb-popover-anchor${className ? ' ' + className : ''}`} ref={wrapRef}>
      {trigger}
      {open && (
        <div className={`tb-popover tb-popover-${align}`} role="menu">
          {children}
        </div>
      )}
    </div>
  );
}
